import { render, staticRenderFns } from "./drag-to-scroll.vue?vue&type=template&id=bfbb186e"
import script from "./drag-to-scroll.vue?vue&type=script&lang=js"
export * from "./drag-to-scroll.vue?vue&type=script&lang=js"
import style0 from "./drag-to-scroll.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports